import FreemiumEventCreatePermissionsStep from './FreemiumEventCreatePermissionsStep';

export default FreemiumEventCreatePermissionsStep;
